import {HoistService, XH} from '@xh/hoist/core';
import {getDefaultOptions} from '../../core/ServiceUtils';
import {Order} from '../data/DataTypes';

export class OrderService extends HoistService {
    async fetchOrdersForPortfolioAsync(portfolioId: number): Promise<Order[]> {
        return XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/orders/portfolio/${portfolioId}/`,
            ...getDefaultOptions()
        });
    }

    async approveOrderAsync(orderId: number) {
        await XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/orders/${orderId}/approve`,
            ...getDefaultOptions()
        });
    }

    async cancelOrderAsync(orderId: number) {
        await XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/orders/${orderId}/cancel`,
            ...getDefaultOptions()
        });
    }
}
